import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { threadClient } from '#pplx_generated/typespec/rest/thread/client.js';
export async function setThreadTitleAPI({ contextUUID, title, rwToken, callback, reason, }) {
    try {
        const { data, error, response } = await threadClient.POST('/rest/thread/set_thread_title', reason, {
            body: {
                context_uuid: contextUUID,
                title,
                read_write_token: rwToken,
            },
            headers: {
                'Content-Type': 'application/json',
            },
        });
        if (error) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                cause: error,
                status: response.status ?? 0,
            });
        }
        callback?.({ data });
    }
    catch (error) {
        callback?.(error);
    }
}
//# sourceMappingURL=useSetThreadTitleAPI.js.map